import type { HostPayoutSettlement } from "./bookings-api";
import { isInactiveDriveShareHistoryForDisplay, type ArchivedDriveShareTripLike } from "@workspace/booking-rules";

/** Missing archival read evidence is unavailable, never assumed off-platform paid. */
export function historicalHostPayoutForDisplay(
  trip: ArchivedDriveShareTripLike,
  settlement: HostPayoutSettlement | null | undefined,
): HostPayoutSettlement | undefined {
  return settlement ?? (isInactiveDriveShareHistoryForDisplay(trip)
    ? { state: "unavailable", method: null, amount: null, currency: null }
    : undefined);
}

/** Shared read-only wording for host detail and Earnings. */
export function historicalHostPayoutLabel(
  settlement: HostPayoutSettlement,
  t: (key: string, defaultValue: string) => string,
): string {
  if (settlement.state === "unavailable") return t("earnings.error_title", "We couldn't load your earnings");
  if (settlement.state !== "paid") return settlement.needsReview
    ? t("earnings.row_settlement_review", "Settlement needs review")
    : t("earnings.row_no_payout_recorded", "No payout recorded");
  if (settlement.method === "transfer") return t("earnings.row_paid_transfer", "Paid via transfer");
  if (settlement.method === "payout_link") return t("earnings.row_paid_payout_link", "Paid via payout link");
  if (settlement.method === "manual") return t("owner_booking.detail.manual_payout", "Manual payout");
  return t("owner_booking.payout_status_paid", "Paid");
}